const normalize = (value: string) => value.trim().toLowerCase();

export const suggestionMatches = (
  suggestions: string[],
  typed: string
): string[] => {
  const query = normalize(typed);
  if (!query) return suggestions;
  return suggestions.filter((suggestion) =>
    normalize(suggestion).includes(query)
  );
};
